import {
  IntegrationsSyncableStateStatusEnum,
  SyncRunSyncingSyncableStateFragment,
} from 'generated/resources/graphql'

export type SyncableStateAggregation = (
  syncableState: SyncRunSyncingSyncableStateFragment
) => number

const defaultAggregation: SyncableStateAggregation = (syncableState) => {
  return syncableState.id
}

export const aggregateStatuses = (
  syncableStates: SyncRunSyncingSyncableStateFragment[],
  aggregation: SyncableStateAggregation = defaultAggregation
): Set<IntegrationsSyncableStateStatusEnum>[] => {
  const aggregationMap = syncableStates.reduce((map, syncableState) => {
    const setId = aggregation(syncableState)
    if (!setId) {
      throw new Error('setId from aggregation function must be present')
    }
    const statusSet = map.get(setId) ?? new Set<IntegrationsSyncableStateStatusEnum>()
    statusSet.add(syncableState.status)
    map.set(setId, statusSet)
    return map
  }, new Map<number, Set<IntegrationsSyncableStateStatusEnum>>())

  return Array.from(aggregationMap.values())
}
